import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getV2ProviderSchedulingGates: build.query<
      GetV2ProviderSchedulingGatesApiResponse,
      GetV2ProviderSchedulingGatesApiArg
    >({
      query: () => ({ url: `/v2/provider/scheduling/gates` }),
    }),
    postV2ProviderSchedulingGates: build.mutation<
      PostV2ProviderSchedulingGatesApiResponse,
      PostV2ProviderSchedulingGatesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/scheduling/gates`,
        method: "POST",
        body: queryArg.createSchedulingGateRequest,
      }),
    }),
    deleteV2ProviderSchedulingGatesByPolicyId: build.mutation<
      DeleteV2ProviderSchedulingGatesByPolicyIdApiResponse,
      DeleteV2ProviderSchedulingGatesByPolicyIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/scheduling/gates/${queryArg.policyId}`,
        method: "DELETE",
      }),
    }),
    patchV2ProviderSchedulingGatesByPolicyId: build.mutation<
      PatchV2ProviderSchedulingGatesByPolicyIdApiResponse,
      PatchV2ProviderSchedulingGatesByPolicyIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/scheduling/gates/${queryArg.policyId}`,
        method: "PATCH",
        body: queryArg.updateSchedulingGateRequest,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type GetV2ProviderSchedulingGatesApiResponse =
  /** status 200 OK */ SchedulingGateListResponse;
export type GetV2ProviderSchedulingGatesApiArg = void;
export type PostV2ProviderSchedulingGatesApiResponse =
  /** status 200 OK */ SchedulingGateResponse;
export type PostV2ProviderSchedulingGatesApiArg = {
  createSchedulingGateRequest: CreateSchedulingGateRequest;
};
export type DeleteV2ProviderSchedulingGatesByPolicyIdApiResponse = unknown;
export type DeleteV2ProviderSchedulingGatesByPolicyIdApiArg = {
  policyId: string;
};
export type PatchV2ProviderSchedulingGatesByPolicyIdApiResponse =
  /** status 200 OK */ SchedulingGateResponse;
export type PatchV2ProviderSchedulingGatesByPolicyIdApiArg = {
  policyId: string;
  updateSchedulingGateRequest: UpdateSchedulingGateRequest;
};
export type PatientApplicability = "new" | "returning" | "all";
export type Checkpoint = "before_calendar" | "at_booking" | "after_booking";
export type GateKind = "paperwork" | "card" | "eligibility" | "fit";
export type SchedulingGateSchema = {
  /** Which patients the gate applies to. */
  applies_to_patient: PatientApplicability;
  /** Where in the booking funnel the gate runs. */
  checkpoint: Checkpoint;
  /** Whether the gate is active. */
  enabled: boolean;
  /** Null = org-wide; set = override for that encounter type. */
  encounter_type_id?: string | null;
  /** Which gate this configures. */
  gate: GateKind;
  /** Gate-specific strictness; null = default behavior. */
  mode?: string | null;
  policy_id: string;
  title?: string | null;
};
export type SchedulingGateListResponse = {
  items: SchedulingGateSchema[];
  total: number;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type PatientApplicability2 = "new" | "returning" | "all";
export type Checkpoint2 = "before_calendar" | "at_booking" | "after_booking";
export type GateKind2 = "paperwork" | "card" | "eligibility" | "fit";
export type SchedulingGateSchema2 = {
  /** Which patients the gate applies to. */
  applies_to_patient: PatientApplicability2;
  /** Where in the booking funnel the gate runs. */
  checkpoint: Checkpoint2;
  /** Whether the gate is active. */
  enabled: boolean;
  /** Null = org-wide; set = override for that encounter type. */
  encounter_type_id?: string | null;
  /** Which gate this configures. */
  gate: GateKind2;
  /** Gate-specific strictness; null = default behavior. */
  mode?: string | null;
  policy_id: string;
  title?: string | null;
};
export type SchedulingGateResponse = {
  gate: SchedulingGateSchema2;
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type PatientApplicability3 = "new" | "returning" | "all";
export type Checkpoint3 = "before_calendar" | "at_booking" | "after_booking";
export type GateKind3 = "paperwork" | "card" | "eligibility" | "fit";
export type CreateSchedulingGateRequest = {
  /** Which patients the gate applies to; defaults to new only. */
  applies_to_patient?: PatientApplicability3;
  /** Where in the booking funnel the gate runs. */
  checkpoint: Checkpoint3;
  /** Whether the gate is active. */
  enabled?: boolean;
  /** Omit for org-wide; set to override one encounter type. */
  encounter_type_id?: string | null;
  /** Which gate to configure. */
  gate: GateKind3;
  /** Gate-specific strictness, e.g. card on_file; eligibility enrichment|hard_gate. Omit for default behavior. */
  mode?: string | null;
  /** Optional display title; generated when omitted. */
  title?: string | null;
};
export type PatientApplicability4 = "new" | "returning" | "all";
export type Checkpoint4 = "before_calendar" | "at_booking" | "after_booking";
export type UpdateSchedulingGateRequest = {
  applies_to_patient?: PatientApplicability4 | null;
  checkpoint?: Checkpoint4 | null;
  enabled?: boolean | null;
  encounter_type_id?: string | null;
  mode?: string | null;
  title?: string | null;
};
